import * as React from 'react';
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';

const ModuleCardWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-module-card-wrapper',
      // Layout
      'flex flex-col gap-3',
      // Dimensões e Espaçamento
      'mr-[-8px] pb-3 pl-[6px] pr-2 pt-[6px]',
      className
    )}
    {...props}
  />
));
ModuleCardWrapper.displayName = 'ModuleCardWrapper';

const ModuleCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-module-card',
      // Estilos de Fundo e Borda
      'rounded-xl bg-white',
      'border border-solid border-neutral-lightest',
      // Sombra e Efeito de Hover (box-shadow)
      'shadow-dropshadow-sm hover:shadow-[0_2px_10px_rgba(0,0,0,0.15)]',
      'transition-all duration-200 ease-in-out',
      // Layout Interno (display: flex)
      'flex items-center justify-between gap-4',
      // Espaçamento e Posição
      'relative cursor-pointer p-4',
      className
    )}
    {...props}
  />
));
ModuleCard.displayName = 'ModuleCard';

const ModuleCardAlert = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-module-card-alert',
      // Layout e Alinhamento
      'hidden flex-nowrap items-start justify-start gap-2 lg:flex',
      // Estilos Visuais
      'rounded-sm bg-[#F1F5FA] p-1',
      // Tipografia e Quebra de Linha
      'line-clamp-none break-words leading-snug',
      // Dimensões
      'w-[400px] max-w-full',
      // SVG
      '[&_svg]:flex-shrink-0',
      className
    )}
    {...props}
  />
));
ModuleCardAlert.displayName = 'ModuleCardAlert';

const ModuleCardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-module-card-header',
      // Layout e Alinhamento
      'flex flex-wrap items-center',
      // Dimensões e Espaçamento
      'w-[260px] max-w-full gap-3',
      // Tipografia
      'leading-none',
      className
    )}
    {...props}
  />
));
ModuleCardHeader.displayName = 'ModuleCardHeader';

const ModuleCardHeaderContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-module-card-header-content',
      // Estilo base
      'w-[60px] flex-grow',
      className
    )}
    {...props}
  />
));
ModuleCardHeaderContent.displayName = 'ModuleCardHeaderContent';

const ModuleCardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'c-module-card-title',
      'w-0 flex-grow truncate',
      // Estilos de Tipografia
      'mb-0 text-base font-bold leading-none',
      'text-primary-dark',
      className
    )}
    {...props}
  />
));
ModuleCardTitle.displayName = 'ModuleCardTitle';

const ModuleCardSubtitle = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-module-card-subtitle', 'mb-1 text-sm font-light leading-none text-neutral', className)}
    {...props}
  />
));
ModuleCardSubtitle.displayName = 'ModuleCardSubtitle';

const ModuleCardText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-module-card-text', 'mb-1 text-sm font-light leading-none text-neutral', 'flex-shrink-0', className)}
    {...props}
  />
));
ModuleCardText.displayName = 'ModuleCardText';

const ModuleCardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-module-card-footer', 'w-full flex-shrink-0 lg:w-[152px]', className)}
    {...props}
  />
));
ModuleCardFooter.displayName = 'ModuleCardFooter';

const ModuleCardLink = React.forwardRef(({ className, ...props }, ref) => (
  <Link
    ref={ref}
    className={cn('c-module-card-link', 'mb-0 flex items-center gap-1 leading-none', className)}
    {...props}
  />
));
ModuleCardLink.displayName = 'ModuleCardLink';

const ModuleCardLinkText = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('c-module-card-link-text', 'truncate text-sm font-bold text-neutral-dark underline', className)}
    {...props}
  />
));
ModuleCardLinkText.displayName = 'ModuleCardLinkText';

export { ModuleCardWrapper, ModuleCard, ModuleCardAlert, ModuleCardHeader, ModuleCardHeaderContent, ModuleCardTitle, ModuleCardSubtitle, ModuleCardText, ModuleCardFooter, ModuleCardLink, ModuleCardLinkText };
